// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__qLxEY","title":"styles_title__2K3gN","card":"styles_card__z7d7o","button":"styles_button__BFii_"};